import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";
import task04 from "./layouts/task-04/task";
import task05 from "./layouts/task-05/task";

const lesson: Lesson = {
  id: "1d439a42-ba2a-4dfc-be34-314ac5e97838",
  publicId: "3",
  name: "Solutions of acoustic equations in the time domain",
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02, task03, task04, task05],
  difficulty: 1,
};

export default lesson;
